export default __webpack_public_path__ + "static/media/radio_select.2a42a9ec.svg";